import Lightbox from '@/components/Lightbox';
import { GalleryUpload } from '@/components_v2/inputs/GalleryUpload';
import ImageCapture from '@/components_v2/inputs/ImageCapture';
import { QuestionModel } from '@/modules/core/domain/interfaces/IFormulary';
import useField from '@/modules/WebForm/hooks/useField';
import { createAnswer } from '@/modules/WebForm/utils';
import { HStack, Wrap, WrapItem } from '@chakra-ui/react';
import React from 'react';

import FormControlComponent from '../FormControlComponent';
import ImagePreview from './Image.Preview';

const ImageContent: React.FC<QuestionModel> = (props) => {
  const { id, maxPictures, questionType } = props;
  const { error, onChange, fieldState, clear } = useField();
  const [urls, setUrls] = React.useState<string[]>([]);

  const value = React.useMemo(() => {
    if (fieldState) {
      if (Array.isArray(fieldState)) {
        setUrls(fieldState.map((v) => v.content));
        return fieldState;
      }
      if (fieldState.content) {
        setUrls([fieldState.content]);
        return [fieldState];
      }
    }
    setUrls([]);
    return [];
  }, [fieldState]);

  const handleChange = React.useCallback(
    (newValue: string[]) => {
      if (newValue.length === 0) {
        clear();
      } else {
        const currentAnswers = [...value];
        const newAnswers: any[] = [];

        newValue.forEach((url) => {
          const index = currentAnswers.findIndex((ans) => ans.content === url);
          if (index !== -1) {
            newAnswers.push(currentAnswers[index]);
            currentAnswers.splice(index, 1);
          } else {
            newAnswers.push(createAnswer(url));
          }
        });

        onChange(newAnswers);
      }
    },
    [onChange, clear, value],
  );

  const onLightbox = React.useCallback(
    (index: number) => {
      Lightbox.openLightbox(
        value.map((v) => v.content),
        index,
      );
    },
    [value],
  );

  const QUESTION_LIMITED_ID = 'e30c2499-60b8-47cd-a806-1b4b953e2335';
  const isLimited =
    id === QUESTION_LIMITED_ID && typeof maxPictures === 'number';
  const disabled = isLimited && value.length >= maxPictures;

  return (
    <FormControlComponent isInvalid={error}>
      <HStack>
        <Wrap>
          <WrapItem alignItems="center">
            <ImageCapture
              urls={urls}
              setUrls={setUrls}
              onChange={handleChange}
              disabled={disabled}
            />
            {questionType !== 'picture' && (
              <GalleryUpload
                urls={urls}
                setUrls={setUrls}
                onChange={handleChange}
                disabled={disabled}
                maxPictures={maxPictures}
                withLimit={isLimited}
              />
            )}
          </WrapItem>
          {value.map((v, index) => (
            <WrapItem key={v.id}>
              <ImagePreview onOpen={() => onLightbox(index)} url={v.content} />
            </WrapItem>
          ))}
        </Wrap>
      </HStack>
    </FormControlComponent>
  );
};

export default ImageContent;
